import React, { ChangeEvent, useCallback, useMemo } from 'react';
import { Col, Form } from 'react-bootstrap';
import t, { strLocaleCompare } from '@rcm/i18n-client';
import { useFindCurrentCountryRuleQuery } from '../../api';
import { useDispatch, useSelector } from 'react-redux';
import { selectShippingState, setShippingState } from '../../slices/shipping';

const ShippingStateField = () => {
    const dispatch = useDispatch();
    const state = useSelector(selectShippingState) || '';
    const countryRulesQuery = useFindCurrentCountryRuleQuery();

    const handleChange = useCallback((e: ChangeEvent<HTMLSelectElement>) => {
        dispatch(setShippingState(e.target.value));
    }, [dispatch]);

    const allowedStates = useMemo(
        () => (
            Object.entries(countryRulesQuery.data?.allowedStates ?? {})
                .sort(([, a], [, b]) => strLocaleCompare(a, b))
        ),
        [countryRulesQuery.data?.allowedStates]
    );

    return (
        countryRulesQuery.data?.countryWithStates &&
        !countryRulesQuery.data?.geoCodeRequired
    ) ? (
        <Form.Group as={Col}>
            <Form.Label>{t('State')}</Form.Label>
            <Form.Select
                disabled={countryRulesQuery.isFetching}
                onChange={handleChange}
                value={state}
            >
                {countryRulesQuery.isFetching && <option value={''} disabled>
                    {t('Loading...')}
                </option>}
                {countryRulesQuery.isSuccess && <>
                    <option value={''} disabled>
                        - {t('Select an Option')} -
                    </option>
                    {allowedStates.map(([value, name]) => (
                        <option value={value} key={value}>{name}</option>
                    ))}
                </>}
            </Form.Select>
        </Form.Group>
    ) : <></>;
};

export default ShippingStateField;
